module.exports = __webpack_public_path__ + "img/multi-store.ff640bf6.png";